import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';

import GaleriaMichelAlvarez from '../../Components/Galerias/MichelAlvarez';
import Desktop from '../../Components/Desktop';

import ma1 from '../../Images/Proyectos/ma.png';
import ma2 from '../../Images/Proyectos/Galerias/Michel-Alvarez/10.png';


const MichelAlvarez = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
      <Fragment>

        <img className="center-img dimensionar-imagen-movil" style={{maxWidth:"100%"}} alt="" src={ma1}></img>

        <div className='container'>
          {window.screen.width >= 993 ? (
            <p className='texto' style={{textAlign:"center"}}>
              Diseñamos y desarrollamos esta E-commerce para Michel Alvarez Studio, <br />
              pioneras de la técnica de “Micropuntura en estrías” en todo México. <br /><br />
              Esta clínica de belleza está enfocada totalmente al área de micropigmentación <br />
              y cuenta con varias certificaciones internacionales. <br /><br />
              El estudio nos solicitó una E-commerce para poder cumplir con la demanda <br />
              de sus clientes internacionales de poder llevar a ellos sus cursos y productos. <br /><br />
              Fue un proyecto grande, pues creamos la plataforma para que su curso <br />
              pudiera llegar a muchas empresas fuera del país interesadas en el tema, <br />
              ofreciéndoles esta capacitación de manera certificada, pues se les da un diploma <br />
              después de concluir el examen dentro de la misma plataforma.
            </p>
          ) :(
            <p className='texto' style={{textAlign:"center"}}>
              Diseñamos y desarrollamos esta E-commerce para Michel Alvarez Studio, 
              pioneras de la técnica de “Micropuntura en estrías” en todo México. <br /><br />
              Esta clínica de belleza está enfocada totalmente al área de micropigmentación 
              y cuenta con varias certificaciones internacionales. <br /><br />
              El estudio nos solicitó una E-commerce para poder cumplir con la demanda 
              de sus clientes internacionales de poder llevar a ellos sus cursos y productos. <br /><br />
              Fue un proyecto grande, pues creamos la plataforma para que su curso 
              pudiera llegar a muchas empresas fuera del país interesadas en el tema, 
              ofreciéndoles esta capacitación de manera certificada, pues se les da un diplom 
              después de concluir el examen dentro de la misma plataforma. 
            </p>
          )}
        </div>

        <Desktop images={{desktop: "michelAlvarezDesktop", laptop:"michelAlvarezLaptop", movil: "michelAlvarezMovil"}} />

        <div className='container'>
          <GaleriaMichelAlvarez/>
        </div>

        <div className='dimensionar-imagen-ma'>
          <img className="center-img" alt="" src={ma2}></img>
        </div>

        <div style={{display:"flex", justifyContent:"center", marginBottom:"50px"}}>
          <div className='btn_1'>
            <a href="#portafolioSofwareOver" style={{color:"#fff"}}>
              <p>
                Ver más del portafolio
              </p>
            </a>
          </div>
        </div>
        
      </Fragment>
    );
}

export default MichelAlvarez;
